import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { GetList, EExcelConnectActions, GetListSuccess } from 'app/connect/connect-excel/store/actions/excel-connector-list.actions';
import { ConnectExcelService } from 'app/connect/core/connect-excel.service';

@Injectable()
export class ExcelConnectorListEffects {

  getExcelConnectorsList$ = createEffect(() =>
    this._actions$.pipe(
      ofType<GetList>(EExcelConnectActions.GetList),
      switchMap(() => this._connectExcelService.getExcelConnectors()),
      switchMap((response: IExcelConnector[]) => of(new GetListSuccess(response))),
    )
  );

  constructor(
    private _connectExcelService: ConnectExcelService,
    private _actions$: Actions
  ) {
  }
}
